














import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import sessionModule, { IUserSession } from '@/store/modules/session';
import UserModule from '@/store/modules/user';
@Component({
  components: {},
})
export default class PersonalIndex extends Vue {
  @State(s => s.session.activeSession) currentSession: IUserSession;
}
